<template>
  <div>
    <GmapMap
      :center="center"
      :zoom="zoom"
      :map-type-id="mapType"
      :options="options"
      style="height: 100%; width: 100%"
      ref="googleMaps"
    >
      <div v-if="renderLine">
        <div v-if="dot && !overlayAllData">
          <gmap-circle
            @click="
              panToLocation(path);
              $emit('dotClicked', index);
            "
            v-for="(path, index) in normalizedData"
            :key="`circle_${index}`"
            :center="path"
            :radius="4"
            :visible="true"
            v-bind:options="{
              fillColor:
                strokeColors[
                  path.value < lowerLimit ? 0 : path.value > upperLimit ? 2 : 1
                ],
              fillOpacity: 1.0,
              strokeColor: strokeColors[path.value - 1],
              strokeOpacity: 0.0,
            }"
          >
          </gmap-circle>
        </div>
        <div v-if="dot && overlayAllData">
          <div
            v-for="(survey, index) in profileData"
            :key="`circleSurvey_${index}`"
          >
            <gmap-circle
              @click="
                panToLocation(path);
                $emit('dotClicked', index);
              "
              v-for="(path, index) in survey"
              :key="`circle_${index}`"
              :center="path"
              :radius="4"
              :visible="true"
              v-bind:options="{
                fillColor:
                  strokeColors[
                    path.value < lowerLimit
                      ? 0
                      : path.value > upperLimit
                      ? 2
                      : 1
                  ],
                fillOpacity: 1.0,
                strokeColor: strokeColors[path.value - 1],
                strokeOpacity: 0.0,
              }"
            >
            </gmap-circle>
          </div>
        </div>
        <div v-if="currentPosition.length > 0">
          <gmap-circle
            v-for="(path, index) in currentPosition"
            :key="`cp_${index}`"
            :center="path"
            :radius="6"
            :visible="true"
            v-bind:options="{
              fillColor: 'black',
              fillOpacity: 1.0,
              strokeOpacity: 0.0,
            }"
          >
          </gmap-circle>
        </div>
        <div v-if="currentRange.length > 0 && showRangeCircles">
          <gmap-circle
            v-for="(path, index) in currentRange"
            :key="`cr_${index}`"
            :center="path"
            :radius="8"
            :visible="true"
            v-bind:options="{
              fillColor: '#5491f5',
              fillOpacity: 0.8,
              strokeOpacity: 0.0,
            }"
          >
          </gmap-circle>
        </div>
        <div v-if="polyline">
          <gmap-polyline
            @click="returnFalse()"
            v-for="(path, index) in paths"
            :key="`line_${index}`"
            :path="path"
            v-bind:options="{
              strokeColor:
                strokeColors[
                  path[0].value < lowerLimit
                    ? 0
                    : path[0].value > upperLimit
                    ? 2
                    : 1
                ],
            }"
          >
          </gmap-polyline>
        </div>
        <div v-if="clustorMarkers != null">
          <gmap-cluster
            :gridSize="30"
            :zoomOnClick="true"
            :enableRetinaIcons="true"
            :minimumClusterSize="10"
            @click="handleClusterClick"
            ref="cluster"
          >
            <gmap-marker
              :key="index"
              v-for="(m, index) in clustorMarkers"
              :position="m"
              :clickable="true"
              :draggable="false"
              :icon="
                m.icon
                  ? m.icon
                  : 'https://simple-software-tools.s3.ap-southeast-2.amazonaws.com/map-icons/mapicon-red-resized.png'
              "
              :title="m.data.id"
              :ref="`marker_${m.data.id}`"
              @click="
                $emit('updatePos', m);
                $emit('showMarkers', [m.data.id]);
              "
            >
            </gmap-marker>
          </gmap-cluster>
        </div>
      </div>
    </GmapMap>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import GmapCluster from "vue2-google-maps/dist/components/cluster";

  export default {
    components: { GmapCluster },
    computed: {
      ...mapGetters([]),
    },
    props: {
      mapType: String,
      options: Object,
      center: Object,
      zoom: Number,
      source: String,
      polyline: {
        type: Boolean,
        default: false,
      },
      dot: {
        type: Boolean,
        default: false,
      },
      normalizedData: {
        type: Array,
        default: null,
      },
      upperLimit: {
        type: [Number, String],
        default: 15,
      },
      lowerLimit: {
        type: [Number, String],
        default: 10,
      },
      overlayAllData: {
        type: Boolean,
        default: false,
      },
      profileData: {
        type: Array,
        default: null,
      },
      clustorMarkers: {
        type: Array,
        default: null,
      },
      showRangeCircles: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      normalizedData: function () {
        this.generatePaths();
      },
      profileData: function () {
        this.generatePaths();
      },
      upperLimit: function () {
        setTimeout(() => {
          this.generatePaths();
        }, 100);
      },
      lowerLimit: function () {
        setTimeout(() => {
          this.generatePaths();
        }, 100);
      },
    },
    data: () => ({
      coords: {
        lng: 10,
        lat: 10,
      },
      paths: [],
      renderLine: false,
      strokeColors: ["#008000", "#eb9c34", "#eb4034"],
      mapsApi: null,
      currentPosition: [],
      currentRange: [],

      // Map markers
      showByIndex: null,
    }),
    mounted() {
      this.generatePaths();
    },
    methods: {
      generatePaths() {
        this.renderLine = false;
        this.paths = [];
        if (this.overlayAllData) {
          this.generatePathsProfileData();
        } else {
          if (this.normalizedData != null) {
            this.generatePathsSurveyData(
              JSON.parse(JSON.stringify(this.normalizedData))
            );
          }
        }
        this.renderLine = true;
      },
      generatePathsProfileData() {
        this.profileData.forEach((normalizedData) => {
          this.generatePathsSurveyData(normalizedData);
        });
      },
      generatePathsSurveyData(normalizedData) {
        let currentPaths = [];
        let currentLimit = null;

        normalizedData.forEach((path) => {
          let pathLimit =
            path.value < this.lowerLimit
              ? 1
              : path.value > this.upperLimit
              ? 3
              : 2;

          if (currentLimit == pathLimit) {
            currentPaths.push(path);
          } else {
            if (currentPaths.length != 0) {
              this.paths.push(currentPaths);
              let startPath = currentPaths[currentPaths.length - 1];
              startPath.value = path.value;
              currentPaths = [startPath, path];
            } else {
              currentPaths = [path];
            }

            currentLimit = pathLimit;
          }
        });
        if (currentPaths.length != 0) {
          this.paths.push(currentPaths);
        }
      },
      panToLocation(position, onlyDraw = false) {
        if (!onlyDraw) {
          this.$refs.googleMaps.$mapPromise.then((map) => {
            map.panTo({ lat: position.lat, lng: position.lng });
          });
        }

        this.currentPosition = [position];
      },
      drawRangePoints(min, max) {
        this.currentRange = [min, max];
      },
      zoomToBounds(coords) {
        this.$refs.googleMaps.$mapPromise.then((map) => {
          this.$gmapApiPromiseLazy().then(() => {
            let bounds = new google.maps.LatLngBounds(
              { lat: coords.minLat, lng: coords.minLng },
              { lat: coords.maxLat, lng: coords.maxLng }
            );
            map.fitBounds(bounds, 20);
          });
        });
      },
      formatDate(date) {
        return moment(date).format("YYYY-MM-DD");
      },
      returnFalse() {
        return false;
      },
      handleClusterClick(cluster) {
        //* Extract markers id list from cluster

        const markersIdList = [];
        const gmapMarkers = cluster.getMarkers();
        gmapMarkers.forEach((m) => markersIdList.push(m.getTitle()));
        this.$refs.googleMaps.$mapPromise.then((map) => {
          if (map.zoom == 21) {
            this.$emit("showMarkers", markersIdList);
          }
        });
      },
    },
  };
</script>

<style lang="scss">
  .gmapInfoWindowHR {
    background: $accent;
    border: 1px solid $accent;
  }
</style>
